import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ApiService } from '../../../../../services/api.service';
import { FileUploadComponent } from '../../../../../common/file-upload/file-upload.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Evento } from '../../../../../shared/interface';

@Component({
  selector: 'app-add-subappalto-accrediti-backoffice',
  templateUrl: './add-subappalto-accrediti-backoffice.component.html',
  styleUrls: ['./add-subappalto-accrediti-backoffice.component.css']
})
export class AddSubappaltoAccreditiBackofficeComponent implements OnInit {

  constructor(
    private apiService: ApiService,    
  ) {}

  @ViewChild('uploadVisuraCamerale', { static: false }) uploadVisuraCamerale!: FileUploadComponent;
  @ViewChild('uploadPos', { static: false }) uploadPos!: FileUploadComponent;
  @ViewChild('uploadAutocertificazione', { static: false }) uploadAutocertificazione!: FileUploadComponent;

  @Input() visible: boolean = false;
  @Input() evento?: Evento;
  
  @Output() close = new EventEmitter<boolean>();  
  
  formSubappalto!: FormGroup;

  ngOnInit(): void {
    this.formSubappalto = new FormGroup({
      ragione_sociale: new FormControl(null, Validators.required),
      piva: new FormControl(null, Validators.required),
      attivita: new FormControl(null, Validators.required),      
      responsabilita: new FormControl(null, Validators.required),
      visura_camerale: new FormControl(null, Validators.required),
      pos: new FormControl(null, Validators.required),
      autocertificazione: new FormControl(null, Validators.required),
    });

    if (!this.evento?.obbligatorieta) {
      this.formSubappalto.get('visura_camerale')?.removeValidators(Validators.required);
      this.formSubappalto.get('pos')?.removeValidators(Validators.required);
      this.formSubappalto.get('autocertificazione')?.removeValidators(Validators.required);
    }

  }
  
  onClose() {
    this.visible = false;    
    this.close.emit(this.visible);
  }

  onAdd() {

    let subappalto = new FormData();
    
    subappalto.append("id_evento", (this.evento?.id! || 0).toString());
    subappalto.append('ragione_sociale', this.formSubappalto.get('ragione_sociale')?.value || '');
    subappalto.append('piva', this.formSubappalto.get('piva')?.value || '');
    subappalto.append('attivita', this.formSubappalto.get('attivita')?.value || '');    
    subappalto.append('visura_camerale', this.formSubappalto.get('visura_camerale')?.value || '');
    subappalto.append('pos', this.formSubappalto.get('pos')?.value || '');
    subappalto.append('autocertificazione', this.formSubappalto.get('autocertificazione')?.value || '');
    
    this.apiService.addSubappalto(subappalto).subscribe({
      next: (data) => this.apiService.setSubappaltiEvento(this.evento?.id!),
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.uploadVisuraCamerale.clearUpload();
        this.uploadPos.clearUpload();
        this.uploadAutocertificazione.clearUpload();

        this.formSubappalto.reset();
        this.formSubappalto.markAsUntouched();
        this.formSubappalto.markAsPristine();    

        this.onClose()
      }
    });    

  }

}
